<template>
  <div v-if="!isForTreasurerOrConsultant || isTreasurerOrConsultant">
    <v-tooltip
      v-model="isTooltipVisible"
      right
    >
      <template v-slot:activator="{}">
        <v-list-group v-model="isSubmenuOpen">
          <template v-slot:activator>
            <v-list-item-icon
              class="flex-shrink-0"
              @mouseenter="startTooltipShowTimer"
              @mouseleave="clearTooltipShowTimer"
            >
              <v-icon class="sidebar--account__icon">{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ title }}</v-list-item-title>
          </template>
          <div
            v-for="link in subLinks"
            :key="link.url"
            class="mb-1"
          >
            <AccountSidebarItem
              :url="link.url"
              :cssClass="link.cssClass"
              :title="link.title"
              :isAccountSidebarOpen="isAccountSidebarOpen"
              :isExternalLink="link.isExternal"
              type="subLink"
              :isForTreasurersOnly="link.isForTreasurersOnly"
              :isForTreasurerOrConsultant="link.isForTreasurerOrConsultant"
              :isTreasurer="isTreasurer"
              :isTreasurerOrConsultant="isTreasurerOrConsultant"
            />
          </div>
        </v-list-group>
      </template>
      <span>{{ title }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import AccountSidebarItem from "@/components/AccountSidebarItem.vue";

export default {
  components: {
    AccountSidebarItem
  },
  props: {
    cssClass: { type: String, default: '' },
    storeLocation: { type: String, default: '' },
    icon: { type: String, required: true },
    title: { type: String, required: true },
    isAccountSidebarOpen: { type: Boolean, required: true },
    isExternalLink: { type: Boolean, default: false },
    subLinks: { type: Array, required: true },
    startSubmenuOpen: { type: Boolean, default: true },
    isTreasurer: { type: Boolean, default: false },
    isTreasurerOrConsultant: { type: Boolean, default: false },
    isForTreasurerOrConsultant: { type: Boolean, default: false },
  },
  data() {
    return {
      isTooltipVisible: false,
      timeoutId: null,
      isSubmenuOpen: true,
      wasSubmenuOpen: false,
    }
  },
  computed: {
  },
  watch: {
    isAccountSidebarOpen(isAccountSidebarOpen, wasAccountSidebarOpen) {
      if (isAccountSidebarOpen == wasAccountSidebarOpen) {
        return;
      }

      if (!isAccountSidebarOpen) {
        this.wasSubmenuOpen = this.isSubmenuOpen;
      }

      this.isSubmenuOpen = isAccountSidebarOpen && this.wasSubmenuOpen;

      if (isAccountSidebarOpen) {
        this.isTooltipVisible = false;
      }
    },
    isSubmenuOpen(isSubmenuOpen) {
      if (isSubmenuOpen) {
        this.$store.dispatch("app/setSecondSidebarOpenState", true);
      }
      if (this.storeLocation) {
        this.$store.dispatch(this.storeLocation, isSubmenuOpen);
      }
    }
  },
  mounted() {
    this.isSubmenuOpen = (this.isAccountSidebarOpen && this.startSubmenuOpen);
    this.wasSubmenuOpen = this.isSubmenuOpen;
  },
  methods: {
    startTooltipShowTimer() {
      if (this.isAccountSidebarOpen) {
        return;
      }

      this.timeoutId = setTimeout(() => {
        this.isTooltipVisible = true;
      }, 400);
    },
    clearTooltipShowTimer() {
      if (this.isAccountSidebarOpen) {
        return;
      }

      clearTimeout(this.timeoutId);
      this.isTooltipVisible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
